import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import Headline from "../../../../components/UI/Headline";

import AdditionalCementConsumption from "./AdditionalCementConsumption";
import AdditionalLenghts from "./AdditionalLenghts";
import DrillingIntoRock from "./DrillingIntoRock";
import DrillingThroughObstacles from "./DrillingThroughObstacles";
import DowntimesEquipmentAndWorkforce from "./DowntimesEquipmentAndWorkforce";
import DowntimesEquipmentOnly from "./DowntimesEquipmentOnly";
import DisposalDrillingSlurry from "./DisposalDrillingSlurry";
import ExecutionStatistics from "./ExecutionStatistics";

import {
  selectAdditionalCementConsumptionIsChecked,
  selectAdditionalLengthsIsChecked,
  selectDrillingIntoRockIsChecked,
  selectDrillingThroughObstaclesIsChecked,
  selectDowntimesEquipmentAndWorkforceIsChecked,
  selectDowntimesEquipmentOnlyIsChecked,
  selectDisposalDrillingSlurryIsChecked,
  selectExecutionStatisticsIsChecked,
  selectAdditionalCementConsumption,
  selectAdditionalLengths,
  selectDrillingIntoRock,
  selectDrillingThroughObstacles,
  selectDowntimesEquipmentAndWorkforce,
  selectDowntimesEquipmentOnly,
  selectDisposalDrillingSlurry,
  selectExecutionStatistics,
  setAdditionalCementConsumptionIsChecked,
  setAdditionalLengthsIsChecked,
  setDrillingIntoRockIsChecked,
  setDrillingThroughObstaclesIsChecked,
  setDowntimesEquipmentAndWorkforceIsChecked,
  setDowntimesEquipmentOnlyIsChecked,
  setDisposalDrillingSlurryIsChecked,
  setExecutionStatisticsIsChecked,
  setAdditionalCementConsumption,
  setAdditionalLengths,
  setDrillingIntoRock,
  setDrillingThroughObstacles,
  setDowntimesEquipmentAndWorkforce,
  setDowntimesEquipmentOnly,
  setDisposalDrillingSlurry,
  setExecutionStatistics,
} from "../../../../store/slices/lvTextSlice";

export default function Positionrequirements() {
  const { t } = useTranslation("translation");

  const additionalCementConsumption = useSelector(selectAdditionalCementConsumption);
  const additionalLengths = useSelector(selectAdditionalLengths);
  const drillingIntoRock = useSelector(selectDrillingIntoRock);
  const drillingThroughObstacles = useSelector(selectDrillingThroughObstacles);
  const downtimesEquipmentAndWorkforce = useSelector(selectDowntimesEquipmentAndWorkforce);
  const downtimesEquipmentOnly = useSelector(selectDowntimesEquipmentOnly);
  const disposalDrillingSlurry = useSelector(selectDisposalDrillingSlurry);

  const additionalCementConsumptionIsChecked = useSelector(
    selectAdditionalCementConsumptionIsChecked
  );
  const additionalLengthsIsChecked = useSelector(selectAdditionalLengthsIsChecked);
  const drillingIntoRockIsChecked = useSelector(selectDrillingIntoRockIsChecked);
  const drillingThroughObstaclesIsChecked = useSelector(selectDrillingThroughObstaclesIsChecked);
  const downtimesEquipmentAndWorkforceIsChecked = useSelector(
    selectDowntimesEquipmentAndWorkforceIsChecked
  );
  const downtimesEquipmentOnlyIsChecked = useSelector(selectDowntimesEquipmentOnlyIsChecked);
  const disposalDrillingSlurryIsChecked = useSelector(selectDisposalDrillingSlurryIsChecked);
  const executionStatisticsIsChecked = useSelector(selectExecutionStatisticsIsChecked);

  const dispatch = useDispatch();
  const dispatchSetAdditionalCementConsumption = (value) =>
    dispatch(setAdditionalCementConsumption(value));
  const dispatchSetAdditionalLengths = (value) => dispatch(setAdditionalLengths(value));
  const dispatchSetDrillingIntoRock = (value) => dispatch(setDrillingIntoRock(value));
  const dispatchSetDrillingThroughObstacles = (value) =>
    dispatch(setDrillingThroughObstacles(value));
  const dispatchSetDowntimesEquipmentAndWorkforce = (value) =>
    dispatch(setDowntimesEquipmentAndWorkforce(value));
  const dispatchSetDowntimesEquipmentOnly = (value) => dispatch(setDowntimesEquipmentOnly(value));
  const dispatchSetDisposalDrillingSlurry = (value) => dispatch(setDisposalDrillingSlurry(value));

  const dispatchSetAdditionalCementConsumptionIsChecked = (value) =>
    dispatch(setAdditionalCementConsumptionIsChecked(value));
  const dispatchSetAdditionalLengthsIsChecked = (value) =>
    dispatch(setAdditionalLengthsIsChecked(value));
  const dispatchSetDrillingIntoRockIsChecked = (value) =>
    dispatch(setDrillingIntoRockIsChecked(value));
  const dispatchSetDrillingThroughObstaclesIsChecked = (value) =>
    dispatch(setDrillingThroughObstaclesIsChecked(value));
  const dispatchSetDowntimesEquipmentAndWorkforceIsChecked = (value) =>
    dispatch(setDowntimesEquipmentAndWorkforceIsChecked(value));
  const dispatchSetDowntimesEquipmentOnlyIsChecked = (value) =>
    dispatch(setDowntimesEquipmentOnlyIsChecked(value));
  const dispatchSetDisposalDrillingSlurryIsChecked = (value) =>
    dispatch(setDisposalDrillingSlurryIsChecked(value));
  const dispatchSetExecutionStatisticsIsChecked = (value) =>
    dispatch(setExecutionStatisticsIsChecked(value));

  return (
    <div className="mt-5">
      <Headline text={t("lvText.positionRequirements.headline")} />
      <p className={"mb-4"}>{t("lvText.positionRequirements.subtext")}</p>
      <AdditionalCementConsumption
        value={additionalCementConsumption}
        set={dispatchSetAdditionalCementConsumption}
        isChecked={additionalCementConsumptionIsChecked}
        onChecked={dispatchSetAdditionalCementConsumptionIsChecked}
      />
      <AdditionalLenghts
        value={additionalLengths}
        set={dispatchSetAdditionalLengths}
        isChecked={additionalLengthsIsChecked}
        onChecked={dispatchSetAdditionalLengthsIsChecked}
      />
      <DrillingIntoRock
        value={drillingIntoRock}
        set={dispatchSetDrillingIntoRock}
        isChecked={drillingIntoRockIsChecked}
        onChecked={dispatchSetDrillingIntoRockIsChecked}
      />
      <DrillingThroughObstacles
        value={drillingThroughObstacles}
        set={dispatchSetDrillingThroughObstacles}
        isChecked={drillingThroughObstaclesIsChecked}
        onChecked={dispatchSetDrillingThroughObstaclesIsChecked}
      />
      <DowntimesEquipmentAndWorkforce
        value={downtimesEquipmentAndWorkforce}
        set={dispatchSetDowntimesEquipmentAndWorkforce}
        isChecked={downtimesEquipmentAndWorkforceIsChecked}
        onChecked={dispatchSetDowntimesEquipmentAndWorkforceIsChecked}
      />
      <DowntimesEquipmentOnly
        value={downtimesEquipmentOnly}
        set={dispatchSetDowntimesEquipmentOnly}
        isChecked={downtimesEquipmentOnlyIsChecked}
        onChecked={dispatchSetDowntimesEquipmentOnlyIsChecked}
      />
      <DisposalDrillingSlurry
        value={disposalDrillingSlurry}
        set={dispatchSetDisposalDrillingSlurry}
        isChecked={disposalDrillingSlurryIsChecked}
        onChecked={dispatchSetDisposalDrillingSlurryIsChecked}
      />
      <ExecutionStatistics
        isChecked={executionStatisticsIsChecked}
        onChecked={dispatchSetExecutionStatisticsIsChecked}
      />
    </div>
  );
}
